export const CategoryTypes = {
    root: 'root',
    child: 'child'
}